export const updateSendValuesHandler = (values) => {
  let sendValues = {};
  sendValues.role_data = {};
  sendValues.role_data.mydocs_permissions = {};
  sendValues.role_data.sm_permissions = {};
  sendValues.role_data.myp_permissions = {};
  sendValues.role_data.settings_app_permissions = {};
  sendValues.role_data.compliance_permissions = {};
  sendValues.role_data.ulp_permissions = {};
  sendValues.role_data.qms_permissions = {};
  sendValues.role_data.secret_key_manager_permissions = {};
  sendValues.role_data.rlp_permissions = {};
  sendValues.role_data.bnf_permissions = {};
  sendValues.role_data.pna_permissions = {};
  sendValues.role_data.eform_permissions = {};
  sendValues.role_data.dashboard_permissions = {};
  sendValues.role_data.index_permissions = {};
  sendValues.role_data.project_permissions = {};
  sendValues.role_data.my_plan_permissions = {};

  sendValues._id = values._id;
  Object.keys(values).forEach((v) => {
    if (v.substring(0, 7) === "my_docs") {
      sendValues.role_data.mydocs_permissions[v] = values[v];
    }
    if (v.substring(0, 2) === "sm") {
      sendValues.role_data.sm_permissions[v] = values[v];
    }
    if (v.substring(0, 3) === "myp") {
      sendValues.role_data.myp_permissions[v] = values[v];
    }
    if (v.substring(0, 12) === "settings_app") {
      sendValues.role_data.settings_app_permissions[v] = values[v];
    }
    if (v.substring(0, 10) === "compliance") {
      sendValues.role_data.compliance_permissions[v] = values[v];
    }
    if (v.substring(0, 3) === "ulp") {
      sendValues.role_data.ulp_permissions[v] = values[v];
    }
    if (v.substring(0, 3) === "qms") {
      sendValues.role_data.qms_permissions[v] = values[v];
    }
    if (v.substring(0, 18) === "secret_key_manager") {
      sendValues.role_data.secret_key_manager_permissions[v] = values[v];
    }
    if (v.substring(0, 3) === "rlp") {
      sendValues.role_data.rlp_permissions[v] = values[v];
    }
    if (v.substring(0, 3) === "bnf") {
      sendValues.role_data.bnf_permissions[v] = values[v];
    }
    if (v.substring(0, 3) === "pna") {
      sendValues.role_data.pna_permissions[v] = values[v];
    }
    if (v.substring(0, 5) === "eform") {
      sendValues.role_data.eform_permissions[v] = values[v];
    }
    if (v.substring(0, 9) === "dashboard") {
      sendValues.role_data.dashboard_permissions[v] = values[v];
    }
    if (v === "index_permission_access") {
      sendValues.role_data.index_permissions.index_permission_access =
        values[v];
    }
    if (v.substring(0, 7) === "my_plan") {
      sendValues.role_data.my_plan_permissions[v] = values[v];
    }
  });
  sendValues.role_data.index_permissions.permission_list = [];
  if (values.index_permission_list) {
    Object.keys(values.index_permission_list).forEach((a) => {
      if (values.index_permission_list[a]) {
        Object.keys(values.index_permission_list[a]).forEach((aa) => {
          sendValues.role_data.index_permissions.permission_list.push({
            hmg_id: a,
            index_id: aa,
            value: values.index_permission_list[a][aa],
          });
        });
      }
    });
  }

  sendValues.role_data.project_permissions.not_allowed_project_list = [];
  if (values.project_permission_list) {
    Object.keys(values.project_permission_list).forEach((a) => {
      if (values.project_permission_list[a]) {
      } else {
        sendValues.role_data.project_permissions.not_allowed_project_list.push(
          a
        );
      }
    });
  }
  return sendValues;
};

export const detailedPermissionFormSetFields = (formTwoFormRef, select) => {
  formTwoFormRef.resetFields();
  let myDocsUpdateInitialValue = null;
  let smUpdateInitialValue = null;
  let mypUpdateInitialValue = null;
  let settingsAppUpdateInitialValue = null;
  let complianceUpdateInitialValue = null;
  let ulpUpdateInitialValue = null;
  let qmsUpdateInitialValue = null;
  let secretKeyManagerUpdateInitialValue = null;
  let rlpUpdateInitialValue = null;
  let bnfUpdateInitialValue = null;
  let pnaUpdateInitialValue = null;
  let eformUpdateInitialValue = null;
  let dashboardUpdateInitialValue = null;
  let myPlanUpdateInitialValue = null;

  if (select && select?.role_data) {
    if (select.role_data.mydocs_permissions) {
      myDocsUpdateInitialValue = select.role_data.mydocs_permissions;
    }
    if (select.role_data.sm_permissions) {
      smUpdateInitialValue = select.role_data.sm_permissions;
    }
    if (select.role_data.myp_permissions) {
      mypUpdateInitialValue = select.role_data.myp_permissions;
    }
    if (select.role_data.settings_app_permissions) {
      settingsAppUpdateInitialValue = select.role_data.settings_app_permissions;
    }
    if (select.role_data.compliance_permissions) {
      complianceUpdateInitialValue = select.role_data.compliance_permissions;
    }
    if (select.role_data.ulp_permissions) {
      ulpUpdateInitialValue = select.role_data.ulp_permissions;
    }
    if (select.role_data.qms_permissions) {
      qmsUpdateInitialValue = select.role_data.qms_permissions;
    }
    if (select.role_data.secret_key_manager_permissions) {
      secretKeyManagerUpdateInitialValue =
        select.role_data.secret_key_manager_permissions;
    }
    if (select.role_data.rlp_permissions) {
      rlpUpdateInitialValue = select.role_data.rlp_permissions;
    }
    if (select.role_data.bnf_permissions) {
      bnfUpdateInitialValue = select.role_data.bnf_permissions;
    }
    if (select.role_data.pna_permissions) {
      pnaUpdateInitialValue = select.role_data.pna_permissions;
    }
    if (select.role_data.eform_permissions) {
      eformUpdateInitialValue = select.role_data.eform_permissions;
    }
    if (select.role_data.dashboard_permissions) {
      dashboardUpdateInitialValue = select.role_data.dashboard_permissions;
    }
    if (select.role_data.my_plan_permissions) {
      myPlanUpdateInitialValue = select.role_data.my_plan_permissions;
    }
  }
  formTwoFormRef.setFieldsValue({
    _id: select?._id,
    my_docs_solution_access:
      myDocsUpdateInitialValue &&
      myDocsUpdateInitialValue.my_docs_solution_access
        ? myDocsUpdateInitialValue.my_docs_solution_access
        : false,
    my_docs_documents_view:
      myDocsUpdateInitialValue &&
      myDocsUpdateInitialValue.my_docs_documents_view
        ? myDocsUpdateInitialValue.my_docs_documents_view
        : false,
    // my_docs_documents_open:
    //   myDocsUpdateInitialValue &&
    //   myDocsUpdateInitialValue.my_docs_documents_open
    //     ? myDocsUpdateInitialValue.my_docs_documents_open
    //     : false,
    my_docs_documents_print:
      myDocsUpdateInitialValue &&
      myDocsUpdateInitialValue.my_docs_documents_print
        ? myDocsUpdateInitialValue.my_docs_documents_print
        : false,
    my_docs_documents_share:
      myDocsUpdateInitialValue &&
      myDocsUpdateInitialValue.my_docs_documents_share
        ? myDocsUpdateInitialValue.my_docs_documents_share
        : false,
    my_docs_documents_delete:
      myDocsUpdateInitialValue &&
      myDocsUpdateInitialValue.my_docs_documents_delete
        ? myDocsUpdateInitialValue.my_docs_documents_delete
        : false,
    my_docs_documents_download:
      myDocsUpdateInitialValue &&
      myDocsUpdateInitialValue.my_docs_documents_download
        ? myDocsUpdateInitialValue.my_docs_documents_download
        : false,
    my_docs_documents_modify:
      myDocsUpdateInitialValue &&
      myDocsUpdateInitialValue.my_docs_documents_modify
        ? myDocsUpdateInitialValue.my_docs_documents_modify
        : false,
    my_docs_documents_add:
      myDocsUpdateInitialValue && myDocsUpdateInitialValue.my_docs_documents_add
        ? myDocsUpdateInitialValue.my_docs_documents_add
        : false,
    my_docs_annotation_add:
      myDocsUpdateInitialValue &&
      myDocsUpdateInitialValue.my_docs_annotation_add
        ? myDocsUpdateInitialValue.my_docs_annotation_add
        : false,
    my_docs_signature_sign:
      myDocsUpdateInitialValue &&
      myDocsUpdateInitialValue.my_docs_signature_sign
        ? myDocsUpdateInitialValue.my_docs_signature_sign
        : false,
    my_docs_recycle_bin_view:
      myDocsUpdateInitialValue &&
      myDocsUpdateInitialValue.my_docs_recycle_bin_view
        ? myDocsUpdateInitialValue.my_docs_recycle_bin_view
        : false,
    my_docs_recycle_bin_restore:
      myDocsUpdateInitialValue &&
      myDocsUpdateInitialValue.my_docs_recycle_bin_restore
        ? myDocsUpdateInitialValue.my_docs_recycle_bin_restore
        : false,
    my_docs_full_text:
      myDocsUpdateInitialValue && myDocsUpdateInitialValue.my_docs_full_text
        ? myDocsUpdateInitialValue.my_docs_full_text
        : false,
    my_docs_flat_file_view:
      myDocsUpdateInitialValue &&
      myDocsUpdateInitialValue.my_docs_flat_file_view
        ? myDocsUpdateInitialValue.my_docs_flat_file_view
        : false,
    my_docs_is_custom_inputs_allowed:
      myDocsUpdateInitialValue &&
      myDocsUpdateInitialValue.my_docs_is_custom_inputs_allowed
        ? myDocsUpdateInitialValue.my_docs_is_custom_inputs_allowed
        : false,
    my_docs_delete_signed_reviewed_reports:
      myDocsUpdateInitialValue &&
      myDocsUpdateInitialValue.my_docs_delete_signed_reviewed_reports
        ? myDocsUpdateInitialValue.my_docs_delete_signed_reviewed_reports
        : false,
    sm_solution_access:
      smUpdateInitialValue && smUpdateInitialValue.sm_solution_access
        ? smUpdateInitialValue.sm_solution_access
        : false,
    sm_hmg_delete:
      smUpdateInitialValue && smUpdateInitialValue.sm_hmg_delete
        ? smUpdateInitialValue.sm_hmg_delete
        : false,
    sm_hotel_delete:
      smUpdateInitialValue && smUpdateInitialValue.sm_hotel_delete
        ? smUpdateInitialValue.sm_hotel_delete
        : false,
    sm_pms_delete:
      smUpdateInitialValue && smUpdateInitialValue.sm_pms_delete
        ? smUpdateInitialValue.sm_pms_delete
        : false,
    sm_role_delete:
      smUpdateInitialValue && smUpdateInitialValue.sm_role_delete
        ? smUpdateInitialValue.sm_role_delete
        : false,
    sm_report_delete:
      smUpdateInitialValue && smUpdateInitialValue.sm_report_delete
        ? smUpdateInitialValue.sm_report_delete
        : false,
    sm_end_user_access:
      smUpdateInitialValue && smUpdateInitialValue.sm_end_user_access
        ? smUpdateInitialValue.sm_end_user_access
        : false,
    sm_user_managment:
      smUpdateInitialValue && smUpdateInitialValue.sm_user_managment
        ? smUpdateInitialValue.sm_user_managment
        : false,
    sm_report_category:
      smUpdateInitialValue && smUpdateInitialValue.sm_report_category
        ? smUpdateInitialValue.sm_report_category
        : false,
    sm_hotels_management:
      smUpdateInitialValue && smUpdateInitialValue.sm_hotels_management
        ? smUpdateInitialValue.sm_hotels_management
        : false,
    sm_barcode_management:
      smUpdateInitialValue && smUpdateInitialValue.sm_barcode_management
        ? smUpdateInitialValue.sm_barcode_management
        : false,
    sm_report_management:
      smUpdateInitialValue && smUpdateInitialValue.sm_report_management
        ? smUpdateInitialValue.sm_report_management
        : false,
    sm_role_managment:
      smUpdateInitialValue && smUpdateInitialValue.sm_role_managment
        ? smUpdateInitialValue.sm_role_managment
        : false,
    sm_onboarding_automation:
      smUpdateInitialValue && smUpdateInitialValue.sm_onboarding_automation
        ? smUpdateInitialValue.sm_onboarding_automation
        : false,
    myp_solution_access:
      mypUpdateInitialValue && mypUpdateInitialValue.myp_solution_access
        ? mypUpdateInitialValue.myp_solution_access
        : false,
    myp_role:
      mypUpdateInitialValue && mypUpdateInitialValue.myp_role
        ? mypUpdateInitialValue.myp_role
        : undefined,
    settings_app_solution_access:
      settingsAppUpdateInitialValue &&
      settingsAppUpdateInitialValue.settings_app_solution_access
        ? settingsAppUpdateInitialValue.settings_app_solution_access
        : false,
    settings_app_grant_access:
      settingsAppUpdateInitialValue &&
      settingsAppUpdateInitialValue.settings_app_grant_access
        ? settingsAppUpdateInitialValue.settings_app_grant_access
        : false,
    settings_app_manage_groups:
      settingsAppUpdateInitialValue &&
      settingsAppUpdateInitialValue.settings_app_manage_groups !== undefined
        ? settingsAppUpdateInitialValue.settings_app_manage_groups
        : true,
    settings_app_manage_signature:
      settingsAppUpdateInitialValue &&
      settingsAppUpdateInitialValue.settings_app_manage_signature !== undefined
        ? settingsAppUpdateInitialValue.settings_app_manage_signature
        : true,
    settings_app_show_report_category:
      settingsAppUpdateInitialValue &&
      settingsAppUpdateInitialValue.settings_app_show_report_category !==
        undefined
        ? settingsAppUpdateInitialValue.settings_app_show_report_category
        : true,
    settings_app_manage_cc_recipients:
      settingsAppUpdateInitialValue &&
      settingsAppUpdateInitialValue.settings_app_manage_cc_recipients !==
        undefined
        ? settingsAppUpdateInitialValue.settings_app_manage_cc_recipients
        : true,
    settings_app_out_of_office:
      settingsAppUpdateInitialValue &&
      settingsAppUpdateInitialValue.settings_app_out_of_office !== undefined
        ? settingsAppUpdateInitialValue.settings_app_out_of_office
        : true,
    settings_app_out_of_office_to_other_signers:
      settingsAppUpdateInitialValue &&
      settingsAppUpdateInitialValue.settings_app_out_of_office_to_other_signers
        ? settingsAppUpdateInitialValue.settings_app_out_of_office_to_other_signers
        : false,
    settings_app_out_of_office_to_other_signers_edit:
      settingsAppUpdateInitialValue &&
      settingsAppUpdateInitialValue.settings_app_out_of_office_to_other_signers_edit
        ? settingsAppUpdateInitialValue.settings_app_out_of_office_to_other_signers_edit
        : false,
    settings_app_post_envelope:
      settingsAppUpdateInitialValue &&
      settingsAppUpdateInitialValue.settings_app_post_envelope !== undefined
        ? settingsAppUpdateInitialValue.settings_app_post_envelope
        : true,

    settings_app_daily_recap:
      settingsAppUpdateInitialValue &&
      settingsAppUpdateInitialValue.settings_app_daily_recap
        ? settingsAppUpdateInitialValue.settings_app_daily_recap
        : false,

    compliance_solution_access:
      complianceUpdateInitialValue &&
      complianceUpdateInitialValue.compliance_solution_access
        ? complianceUpdateInitialValue.compliance_solution_access
        : false,
    compliance_upload:
      complianceUpdateInitialValue &&
      complianceUpdateInitialValue.compliance_upload
        ? complianceUpdateInitialValue.compliance_upload
        : false,
    compliance_signature:
      complianceUpdateInitialValue &&
      complianceUpdateInitialValue.compliance_signature
        ? complianceUpdateInitialValue.compliance_signature
        : false,
    compliance_holistic_view:
      complianceUpdateInitialValue &&
      complianceUpdateInitialValue.compliance_holistic_view
        ? complianceUpdateInitialValue.compliance_holistic_view
        : false,
    compliance_report_drilldown:
      complianceUpdateInitialValue &&
      complianceUpdateInitialValue.compliance_report_drilldown
        ? complianceUpdateInitialValue.compliance_report_drilldown
        : "Only Missing",
    compliance_signature_report_drilldown:
      complianceUpdateInitialValue &&
      complianceUpdateInitialValue.compliance_signature_report_drilldown
        ? complianceUpdateInitialValue.compliance_signature_report_drilldown
        : "Only Missing",
    compliance_view_signature_certificate:
      complianceUpdateInitialValue &&
      complianceUpdateInitialValue.compliance_view_signature_certificate
        ? complianceUpdateInitialValue.compliance_view_signature_certificate
        : false,
    compliance_view_reports:
      complianceUpdateInitialValue &&
      complianceUpdateInitialValue.compliance_view_reports
        ? complianceUpdateInitialValue.compliance_view_reports
        : false,
    compliance_excel_export:
      complianceUpdateInitialValue &&
      complianceUpdateInitialValue.compliance_excel_export !== undefined
        ? complianceUpdateInitialValue.compliance_excel_export
        : true,
    compliance_excel_report_share:
      complianceUpdateInitialValue &&
      complianceUpdateInitialValue.compliance_report_excel_share !== undefined
        ? complianceUpdateInitialValue.compliance_report_excel_share
        : process.env?.REACT_APP_PLATFORM_TYPE !== "MARRIOTT",
    compliance_view_signer_count:
      complianceUpdateInitialValue &&
      complianceUpdateInitialValue.compliance_view_signer_count
        ? complianceUpdateInitialValue.compliance_view_signer_count
        : false,
    compliance_secondary_view:
      complianceUpdateInitialValue &&
      complianceUpdateInitialValue.compliance_secondary_view
        ? complianceUpdateInitialValue.compliance_secondary_view
        : false,
    compliance_soft_live_hotel_status:
      complianceUpdateInitialValue?.compliance_soft_live_hotel_status
        ? complianceUpdateInitialValue.compliance_soft_live_hotel_status
        : "default",
    compliance_filter_by_report_category:
      complianceUpdateInitialValue?.compliance_filter_by_report_category ??
      true,
    compliance_filter_by_report_name:
      complianceUpdateInitialValue?.compliance_filter_by_report_name ?? false,
    compliance_signature_timestamp:
      complianceUpdateInitialValue?.compliance_signature_timestamp ?? false,
    ulp_solution_access:
      ulpUpdateInitialValue && ulpUpdateInitialValue.ulp_solution_access
        ? ulpUpdateInitialValue.ulp_solution_access
        : false,
    ulp_add_new_report:
      ulpUpdateInitialValue && ulpUpdateInitialValue.ulp_add_new_report
        ? ulpUpdateInitialValue.ulp_add_new_report
        : false,
    ulp_payroll_user:
      ulpUpdateInitialValue && ulpUpdateInitialValue.ulp_payroll_user
        ? ulpUpdateInitialValue.ulp_payroll_user
        : "false",
    ulp_onboarding_team_access:
      ulpUpdateInitialValue && ulpUpdateInitialValue.ulp_onboarding_team_access
        ? ulpUpdateInitialValue.ulp_onboarding_team_access
        : false,
    ulp_file_mapping_update:
      ulpUpdateInitialValue && ulpUpdateInitialValue.ulp_file_mapping_update
        ? ulpUpdateInitialValue.ulp_file_mapping_update
        : false,

    qms_solution_access:
      qmsUpdateInitialValue && qmsUpdateInitialValue.qms_solution_access
        ? qmsUpdateInitialValue.qms_solution_access
        : false,
    qms_smart_scanning_more_details:
      qmsUpdateInitialValue &&
      qmsUpdateInitialValue.qms_smart_scanning_more_details
        ? qmsUpdateInitialValue.qms_smart_scanning_more_details
        : false,
    qms_gm_access:
      qmsUpdateInitialValue && qmsUpdateInitialValue.qms_gm_access
        ? qmsUpdateInitialValue.qms_gm_access
        : false,
    qms_download_permission:
      qmsUpdateInitialValue && qmsUpdateInitialValue.qms_download_permission
        ? qmsUpdateInitialValue.qms_download_permission
        : false,
    qms_onboarding_team_access:
      qmsUpdateInitialValue && qmsUpdateInitialValue.qms_onboarding_team_access
        ? qmsUpdateInitialValue.qms_onboarding_team_access
        : false,

    secret_key_manager_solution_access:
      secretKeyManagerUpdateInitialValue &&
      secretKeyManagerUpdateInitialValue.secret_key_manager_solution_access
        ? secretKeyManagerUpdateInitialValue.secret_key_manager_solution_access
        : false,
    bnf_solution_access:
      bnfUpdateInitialValue && bnfUpdateInitialValue.bnf_solution_access
        ? bnfUpdateInitialValue.bnf_solution_access
        : false,

    pna_solution_access:
      pnaUpdateInitialValue && pnaUpdateInitialValue.pna_solution_access
        ? pnaUpdateInitialValue.pna_solution_access
        : false,

    eform_solution_access:
      eformUpdateInitialValue && eformUpdateInitialValue.eform_solution_access
        ? eformUpdateInitialValue.eform_solution_access
        : false,

    dashboard_pms_tile_show:
      dashboardUpdateInitialValue &&
      dashboardUpdateInitialValue.dashboard_pms_tile_show
        ? dashboardUpdateInitialValue.dashboard_pms_tile_show
        : false,
    dashboard_marriott_fosse_show:
      dashboardUpdateInitialValue &&
      dashboardUpdateInitialValue.dashboard_marriott_fosse_show
        ? dashboardUpdateInitialValue.dashboard_marriott_fosse_show
        : false,
    my_plan_solution_access:
      myPlanUpdateInitialValue &&
      myPlanUpdateInitialValue.my_plan_solution_access
        ? myPlanUpdateInitialValue.my_plan_solution_access
        : false,
  });
};